<template>
  <div class="chart_dialog">
    <div ref="chart" class="chart"></div>
    <div class="alarm">
      <div v-for="(item, index) in alarm" :key="index">
        <span>{{item.name}}</span>
        <span class="value">{{item.value || 0}}</span>
      </div>
    </div>
 </div>
 </template>

<script>
// import * as echarts from 'echarts'
import { px2vw } from '@/utils/util'
export default {
  name: 'ChartDialog',
  data () {
    return {
      alarm: [{
        name: 'SOS求助',
        value: 0
      }]
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || 1
    }
  },
  watch: {
    projectId (val) {
      if (val) {
        this._chart && this._chart.dispose()
      }
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  destroyed () {
    this._chart && this._chart.dispose()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.worker.selectWorkerSum, {
        projectId: this.projectId
      }).then(res => {
        this.refreshEchart(res.deviceCount)
        this.$event.$emit('drawDevice', res.deviceList.list || [])
      })
    },
    // 重新绘制
    refreshEchart (res) {
      this._chart && this._chart.clear()
      this.$nextTick(() => {
        this.renderPie(res)
      })
      this.alarm[0].value = res.sosCount
    },
    renderPie (res) {
      const color = ['#89F3F7', '#E51212', '#FEE186']
      const title = {
        name: '在岗率',
        per: res.onDevicePer || 0
      }
      const data = [{
        name: '在岗',
        value: res.onWorkCount || 0
      },
      {
        name: '脱岗',
        value: res.offWorkCount || 0
      }]
      setTimeout(() => {
        this.renderChart(data, color, title)
      }, 500)
    },
    renderChart (data, color, title) {
      this._chart = echarts.init(this.$refs.chart)
      const option = {
        tooltip: {
          show: false,
          formatter: '{a} <br/>{b}: {d}%',
          textStyle: {
            fontSize: px2vw(12)
          }
        },
        title: {
          show: title.name,
          text: title.per + '%',
          subtext: title.name,
          left: '28%',
          textAlign: 'center',
          top: '30%',
          textStyle: {
            color: '#000000',
            fontSize: px2vw(14),
            fontFamily: 'PingFangSC, PingFang SC'
          },
          subtextStyle: {
            color: '#000000',
            fontSize: px2vw(14),
            lineHeight: 0,
            fontFamily: 'PingFangSC, PingFang SC'
          }
        },
        legend: {
          orient: 'vertical',
          top: 'center',
          left: '60%',
          icon: 'circle',
          itemWidth: px2vw(6),
          formatter: (name) => {
            const index = data.findIndex((item) => item.name === name)
            const arr = '{a|' + name + '}{b|' + data[index].value + '}'
            return arr
          },
          textStyle: {
            fontSize: px2vw(14),
            color: '#000000',
            align: 'center',
            rich: {
              a: {
                padding: [0, 0, 0, px2vw(2)]
              },
              b: {
                padding: [px2vw(15), 0, px2vw(15), px2vw(28)]
              }
            }
          }
        },
        color: color,
        series: [
          {
            // avoidLabelOverlap: false,
            hoverOffset: 0,
            type: 'pie',
            radius: ['90%', '100%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              position: 'center'
            },
            zlevel: 4,
            itemStyle: {
              normal: {
                borderColor: 'rgba(0, 0, 0, 1)',
                borderWidth: 0,
                color: (value) => {
                  return color[value.dataIndex]
                }
                // shadowColor: 'rgba(0,0,0,0.4)',
                // shadowBlur: 10
              }
            },
            data: data,
            labelLine: {
              show: false
            }
          },
          {
            labelLine: {
              show: false
            },
            itemStyle: {
              opacity: 0.2,
              borderColor: '#ffffff',
              borderWidth: 2
            },
            type: 'pie',
            hoverAnimation: false,
            radius: ['70%', '90%'],
            center: ['30%', '50%'],
            label: {
              normal: {
                show: false
              }
            },
            data: data,
            zlevel: -1
          }
        ]
      }
      this._chart.clear()
      this._chart.setOption(option)
    }
  }
}
</script>

 <style scoped lang='scss'>
 .chart_dialog{
  z-index: 909;
  min-height: 173px;
  color: var(--header-bar-title-color);
  border-radius: 10px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  .chart{
    width: 100%;
    height: 110px;
    margin: 30px;
  }
  .alarm{
    display: flex;
    justify-content: space-around;
    width: 100%;
    border-top: 1px solid #EAEAEA;
    >div{
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      padding: 15px;
      .value{
        color: #E51212;
      }
    }
  }
 }
 </style>
